import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { loginUser, logoutUser, initializeKeycloak } from '../keycloak';
import { trackEvent, NAVIGATION } from '../utils/googleAnalytics';
import GLOLogo from '../assets/logos/GLO_SEAL_COLOR-01.png';
import texasAMLogo from '../assets/logos/TAMUWhiteLogo.svg';
import tdisLogo from '../assets/logos/TDISLogoWhite.png';
import clsx from 'clsx';

export const Header = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleAuthChange = authStatus => {
    setIsAuthenticated(authStatus);
  };

  const toggleAuth = () => {
    if (isAuthenticated) {
      logoutUser();
      setIsAuthenticated(false);
    } else {
      loginUser();
    }
  };

  useEffect(() => {
    initializeKeycloak(handleAuthChange);
  }, []);

  return (
    <header className="z-10 min-h-16 w-full bg-banner">
      <div className="flex flex-col items-center gap-1 px-3 sm:px-8 md:flex-row md:justify-between md:gap-4 md:px-10">
        <div className="order-1 flex items-center gap-4 sm:gap-6 md:order-1">
          <a
            href="https://portal.cloud.tdis.io/"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent(NAVIGATION, 'tdis site link')}
          >
            <img src={tdisLogo} alt="TDIS Logo" className="h-10" />
          </a>
          <a
            href="https://www.glo.texas.gov/"
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent(NAVIGATION, 'glo site link')}
          >
            <img src={GLOLogo} alt="GLO Logo" className="h-10" />
          </a>
          {/* This Texas A&M logo is only visible on mobile */}
          <a
            href="https://www.tamu.edu/index.html"
            target="_blank"
            rel="noreferrer"
            aria-label="Texas A&M University logo"
            onClick={() => trackEvent(NAVIGATION, 'texas a&m site link')}
            className="md:hidden"
          >
            <img src={texasAMLogo} alt="Texas A&M logo" className="h-16" />
          </a>
        </div>

        {/* Go home and clear store to clear search params */}
        <NavLink
          to="/"
          onClick={() => trackEvent(NAVIGATION, 'home link')}
          className="order-2 my-4 cursor-default text-center text-2xl text-white no-underline md:order-2 md:my-0"
        >
          Flood Risk Explorer
        </NavLink>

        {/* This Texas A&M logo is only visible on desktop */}
        <a
          href="https://www.tamu.edu/index.html"
          target="_blank"
          rel="noreferrer"
          aria-label="Texas A&M University logo"
          onClick={() => trackEvent(NAVIGATION, 'texas a&m site link')}
          className="hidden md:order-3 md:block"
        >
          <img src={texasAMLogo} alt="Texas A&M logo" className="h-16" />
        </a>

        <button
          className={clsx('link-button', 'order-3 !text-lg !text-white md:!my-0 md:!text-sm')}
          onClick={toggleAuth}
          title={isAuthenticated ? 'Click to logout' : 'Click to login'}
        >
          {isAuthenticated ? 'Logout' : 'Login'}
        </button>
      </div>
    </header>
  );
};
